import React from 'react'
import Button from '@/button'

import './styles.css'

const GetStartedButton = () => (
  <div className="tc">
    <Button
      to="/get_started"
      color="gold-gradient"
      layout="rounded"
      size="xlg"
      isStretch
      className='mw304'
    >
      Get started
    </Button>
  </div>
)

export default GetStartedButton



// WEBPACK FOOTER //
// ./src/components/get-started-button/get-started-button.js